(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('TkbTransferDialogController', TkbTransferDialogController);

    TkbTransferDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TkbTransfer', 'Customer'];

    function TkbTransferDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TkbTransfer, Customer) {
        var vm = this;

        vm.tkbTransfer = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.customers = Customer.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.tkbTransfer.id !== null) {
                TkbTransfer.update(vm.tkbTransfer, onSaveSuccess, onSaveError);
            } else {
                TkbTransfer.save(vm.tkbTransfer, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bozorakaAdminApp:tkbTransferUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.lastModifiedDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
